import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { IconButtonComponent } from '@shared/buttons';

@Component({
  selector: 'la-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconButtonComponent, MatDialogModule],
})
export class DialogHeaderComponent {
  @Input() close = true;
  @Input() back?: () => void = undefined;
}
